
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MenuItemAddEdit from '@/views/DashView/MenuItem/MenuItemAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuItemItem {
  id: string = '';
  outletCode: string = '';
  menuItemCode: string = '';
  menuGroupCode: string = '';
  sequence: number = 0;
  isTaxable: boolean = false;
  isActive: boolean = false;
  isCD: boolean = false;
}

@Component({
  components: {
    editor: MenuItemAddEdit
  }
})
export default class MenuItemList extends RemoteDataTable<MenuItemItem> {
  public pageTitle: string = 'Menu Item List';

  public newButtonText: string = 'New Menu Item';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outOfStock', label: 'Is Out Of Stock' }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'outletName', label: 'Outlet Name' }),
    new RemoteDataField({ key: 'menuItemCode', label: 'Menu Item Code' }),
    new RemoteDataField({ key: 'name', label: 'Menu Item Name' }),
    new RemoteDataField({ key: 'menuGroupCode', label: 'Menu Group Code' }),
    new RemoteDataField({ key: 'menu_group_name', label: 'Menu Group Name' }),
    new RemoteDataField({ key: 'sequence', label: 'Sequence' }),
    new RemoteDataField({ key: 'isTaxable', label: 'Is Taxable' }),
    new RemoteDataField({ key: 'isActive', label: 'Is Active' }),
    new RemoteDataField({ key: 'isCD', label: 'Is CD' })
  ];

  // to get page data
  get items(): MenuItemItem[] {
    return this.$store.getters.GetAllMenuItem;
  }

  get paging(): MenuItemItem[] {
    return this.$store.getters.PagingMenuItem;
  }

  get sorting(): MenuItemItem[] {
    return this.$store.getters.SortingMenuItem;
  }

  get filtering(): MenuItemItem[] {
    return this.$store.getters.FilteringMenuItem;
  }
  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuItem', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }
  mounted() {
    if (!this.$store.state.commonUtils.isFetchingData) {
      this.reload();
    }
  }
  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuItem', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuItem.pagingMenuItem.page = 1;
    }
    this.$store.dispatch('GetAllMenuItem');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMenuItem', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuItem.pagingMenuItem.size = page;
    this.$store.dispatch('GetAllMenuItem');
  }

  changeStockStatus(id, status) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: `${
        status
          ? 'you want to add this menu item back to stock?'
          : 'you want to mark this menu item out of stock?'
      }`,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willChange => {
      if (willChange) {
        const payload = { id, OutOfStock: !status };
        this.$store.dispatch('changeStockStatus', payload);
      }
    });
  }
}
